import { useForm } from 'react-hook-form';
import EditarSeguimientoPedido from '../../../../../shared/components/EditarSeguimientoPedido';
import { toast } from 'react-toastify';
import { ENVIOS_API } from '../../../../../shared/services/envios';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateShippingResults } from '../../../../../../../../redux/envios';
import { CircularProgress } from '@mui/material';

const UpdateSeguimientoForm = ({ envio }) => {
    const serviciosEnvio = useSelector((state) => {
        return state.servicios_envio;
    });
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        formState: { errors },
        handleSubmit,
        setValue,
        watch,
        getValues,
        unregister,
    } = useForm({
        defaultValues: {
            id: envio.id,
            url_seguimiento: envio.url_seguimiento,
            numero_seguimiento: envio.numero_seguimiento,
        },
    });

    const onSubmit = async (data) => {
        if (isLoading) return;

        const newData = getDataChanged(data.envios[data.id], data);
        if (!newData) return;

        setIsLoading(true);
        newData.id = data.id;
        try {
            const res = await ENVIOS_API.update(newData);
            if (res?.success) {
                toast.success(res?.message);
                if (newData.servicio_envio_id) {
                    const servicioEnvio = serviciosEnvio.find(
                        (item) => item.id === newData.servicio_envio_id
                    );
                    newData.servicio_envio_nombre = servicioEnvio?.nombre || '';
                }
                return dispatch(updateShippingResults(newData));
            }
            return toast.error('No se ha podido actualizar el envío!');
        } catch (e) {
            return toast.error(e.message);
        } finally {
            setIsLoading(false);
        }
    };

    const getDataChanged = (newData, oldData) => {
        const changedInfo = {};
        const {
            url_seguimiento: newUrl,
            numero_seguimiento: newNum,
            transportista_id,
            servicio_envio_id,
        } = newData;
        const { url_seguimiento: oldUrl, numero_seguimiento: oldNum } = oldData;

        if (newUrl !== oldUrl && oldUrl !== null && newUrl !== '') {
            changedInfo.url_seguimiento = newUrl;
        }
        if (
            newNum !== oldNum &&
            (oldNum !== '-' || (oldNum === '-' && newNum !== ''))
        ) {
            changedInfo.numero_seguimiento = newNum === '' ? '-' : newNum;
        }
        if (transportista_id) {
            changedInfo.transportista_id = parseInt(transportista_id);
        }
        if (servicio_envio_id) {
            changedInfo.servicio_envio_id = parseInt(servicio_envio_id);
        }
        return Object.keys(changedInfo).length > 0 ? changedInfo : null;
    };

    return (
        <form className="form col-12 mb-4" onSubmit={handleSubmit(onSubmit)}>
            <EditarSeguimientoPedido
                envio={envio}
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                getValues={getValues}
                unregister={unregister}
            />
            <div className="mt-4 shipping-form-btn">
                <button
                    type="submit"
                    className="btn btn-primary shipping-form-btn__btn"
                >
                    {isLoading ? (
                        <CircularProgress color="inherit" size={23} />
                    ) : (
                        'Confirmar'
                    )}
                </button>
            </div>
        </form>
    );
};

export default UpdateSeguimientoForm;
